import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #1a1a1a;
  padding: 40px 0;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 0 56px 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 1369px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0;
    max-width: 340px;
    gap: 30px;
  }

  h1 {
    color: #c3c3c3;
    font-size: 32px;
    font-style: normal;
    font-weight: 275;
    line-height: 40px;

    span {
      color: #f16024;
    }

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 32px;
    }
  }
`;

export const StyledHr = styled.hr`
  flex: 1;
  border: 1px solid #c3c3c3;
  margin: 0 20px;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  max-width: 1369px;
  width: 100%;
  margin: 80px auto;
  padding: 70px 20px 10px 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    max-width: 340px;
    margin: 24px auto 0;
    padding: 0;
    gap: 40px;
  }
`;

export const TextBox2 = styled.div`
  flex: 1;
  padding: 10px;
  color: #c3c3c3;

  @media (max-width: 768px) {
    padding: 0;
  }

  p {
    font-family: 'Open Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    margin-bottom: 10px;
    padding-left: 70px;

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 20px;
      padding-left: 0;
    }
  }

  span {
    color: #f16024;
  }
`;

export const ImageBox = styled.div`
  flex: 1;
  text-align: center;

  img {
    max-width: 100%;
    height: auto;

    @media (max-width: 768px) {
      max-width: 60%;
    }
  }
`;
